import { deleteInvite } from '../../../modules/member/member.repository';

export const deleteInviteUseCase = (appMemberId: number): Promise<void> => {
  return deleteInvite(appMemberId);
};
